export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL as string;
export const API_URL = import.meta.env.VITE_API_URL as string;
